'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = OnlinepbxModalContainer;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var CrossIcon = function () {
  function CrossIcon(props) {
    return _react2['default'].createElement(
      'svg',
      props,
      _react2['default'].createElement('path', {
        d: 'M15 5L5 15M5 5l10 10',
        stroke: '#A8A4B9',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      })
    );
  }

  return CrossIcon;
}();

CrossIcon.defaultProps = {
  width: '20',
  height: '20',
  viewBox: '0 0 20 20',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
};
function OnlinepbxModalContainer(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      className = _ref.className,
      classNameContainer = _ref.classNameContainer;

  return _react2['default'].createElement(
    'div',
    {
      onClick: onClick,
      className: (0, _classnames2['default'])('onlinepbx__lib__modal__container', classNameContainer) },
    _react2['default'].createElement(
      'button',
      {
        onClick: onClick,
        className: 'onlinepbx__lib__modal__container__hide' },
      _react2['default'].createElement(CrossIcon, { className: 'onlinepbx__lib__modal__container__cross' })
    ),
    _react2['default'].createElement(
      'div',
      {
        onClick: function () {
          function onClick(evt) {
            return evt.stopPropagation();
          }

          return onClick;
        }(),
        className: (0, _classnames2['default'])('onlinepbx__lib__modal__container__content', className) },
      children
    )
  );
}